import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import axiosIns from "../common/interceptor/axios-interceptor";

// Allocation
// Fetch Allocation Data
export const fetchAllocationData = async (filters = {}, noCache = false) => {
  try {
    const params = {
      ...filters,
      noCache: noCache.toString(),
    };

    const res = await axiosIns.get(`rackstar/allocation`, {
      params,
    });
    return getSuccessRes(res.data, "Allocation data fetched successfully.");
  } catch (error) {
    throw getErrorRes(error, "Failed to fetch allocation data.");
  }
};

// Fetch Allocation by ID
export const fetchAllocationById = async (id) => {
  try {
    const res = await axiosIns.get(`rackstar/allocation/${id}`);
    return getSuccessRes(res.data, "Allocation fetched successfully.");
  } catch (error) {
    throw getErrorRes(error, "Failed to fetch allocation.");
  }
};

// Add a new Allocation entry
export const addAllocationData = async (allocation, toastId) => {
  try {
    const res = await axiosIns.post(`rackstar/allocation`, allocation);
    return getSuccessRes(res.data, "Allocation added successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add allocation.");
  }
};

// Update an existing Allocation entry
export const updateAllocationData = async (id, allocation, toastId) => {
  try {
    const res = await axiosIns.put(`rackstar/allocation/${id}`, allocation);
    return getSuccessRes(res.data, "Allocation updated successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update allocation.");
  }
};

// Delete an Allocation entry
export const deleteAllocationData = async (id, toastId) => {
  try {
    const res = await axiosIns.delete(`rackstar/allocation/${id}`);
    return getSuccessRes(res.data, "Allocation deleted successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to delete allocation.");
  }
};

// AllocationDaily
// Fetch AllocationDaily Data
export const fetchAllocationDailyData = async (
  filters = {},
  noCache = false
) => {
  try {
    const params = {
      ...filters,
      noCache: noCache.toString(),
    };

    const res = await axiosIns.get(`rackstar/allocationdaily`, {
      params,
    });
    return getSuccessRes(
      res.data,
      "AllocationDaily data fetched successfully."
    );
  } catch (error) {
    throw getErrorRes(error, "Failed to fetch allocation daily data.");
  }
};

// Fetch AllocationDaily by ID
export const fetchAllocationDailyById = async (id) => {
  try {
    const res = await axiosIns.get(`rackstar/allocationdaily/${id}`);
    return getSuccessRes(res.data, "AllocationDaily fetched successfully.");
  } catch (error) {
    throw getErrorRes(error, "Failed to fetch allocation daily.");
  }
};

// Add a new AllocationDaily entry
export const addAllocationDailyData = async (allocationDaily, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/allocationdaily`,
      allocationDaily
    );
    return getSuccessRes(res.data, "AllocationDaily added successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add allocation daily.");
  }
};

// Update an existing AllocationDaily entry
export const updateAllocationDailyData = async (
  id,
  allocationDaily,
  toastId
) => {
  try {
    const res = await axiosIns.put(
      `rackstar/allocationdaily/${id}`,
      allocationDaily
    );
    return getSuccessRes(res.data, "AllocationDaily updated successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update allocation daily.");
  }
};

//Update multiple entry
export const updateMultipleAllocationDaily = async (editedRows) => {
  try {
    const updates = Object.values(editedRows);

    // Send updates one by one or in parallel
    for (const update of updates) {
      await axiosIns.put(
        `rackstar/allocationdaily/${update.aD_Key}`,
        update
      );
    }

    return getSuccessRes(null, "Daily allocation updated successfully");
  } catch (error) {
    const errMessage = handleErrorMessage(error);
    throw getErrorRes(errMessage, "Failed to update daily allocation");
  }
};

// Delete an AllocationDaily entry
export const deleteAllocationDailyData = async (id, toastId) => {
  try {
    const res = await axiosIns.delete(`rackstar/allocationdaily/${id}`);
    return getSuccessRes(res.data, "AllocationDaily deleted successfully!");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to delete allocation daily.");
  }
};

//Send Allocation Email
export const sendAllocationEmail = async (payload) => {
  try {
    const res = await axiosIns.post(
      `rackstar/send-allocation-daily-email`,
      payload
    );
    return getSuccessRes(res.data, "Email sent successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, "Failed to send email.");
  }
};
